import React, { FC } from 'react'
import styled from 'styled-components'

import type { ProductAggregations, UseProducts } from '../../../../lib/products'
import Spinner from '../../../Spinner'
import Filters from './Filters'

export interface FiltersContainerProps {
  className?: string
  aggregations: ProductAggregations | null | undefined
  listing: UseProducts['listing']
  loading: boolean
}

const FiltersContainer: FC<FiltersContainerProps> = ({
  className,
  aggregations,
  listing,
  loading,
}) => (
  <div className={className}>
    {loading ? <Spinner loading /> : <Filters aggregations={aggregations} listing={listing} />}
  </div>
)

const StyledFiltersContainer = styled(FiltersContainer)(({ theme }) => {
  return {
    display: 'none',
    backgroundColor: theme.colors.grayscale.white,
    // Match the Bootstrap breakpoint used by the header:
    '@media(min-width: 992px)': {
      display: 'initial',
      marginRight: '30px',
      padding: '40px',
      width: '291px',
    },
  }
})

export default StyledFiltersContainer
